export default {
  1: 'Dress',
  2: 'Shirt',
  3: 'Sweater',
  4: 'TShirt',
  5: 'Pants',
  6: 'Panties',
  7: 'Skirt',
  8: 'Jacket',
  11: 'Dress Strapless',
  12: 'Top',
  13: 'Shorts',
  14: 'Coat',
  15: 'Dress ALine',
  16: 'Dress Sleeve',
  17: 'Shoe',
  18: 'Bag',
  19: 'Clutch',
  20: 'Tunic Sleeve',
  21: 'Glasses Wellington',
  22: 'Glasses Square',
  23: 'Glasses Oval',
  24: 'Glasses Boston',
  25: 'Wallet'
}
// todo: this should be from API? or virtusize.js
